// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

const AddCardWrapper = dynamic(() => import('./AddCardWrapper').then(mod => mod.AddCardWrapper));

export const AddCardConfig = {
  emptyLabel: 'addcard',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/addcard`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AddCardEditable = (props: any) => {

  return props?.cqPath?.includes('datapagecomponent') ? (
    <AddCardWrapper {...props} />
  ) : (
    <EditableComponent config={AddCardConfig} {...props}>
      <AddCardWrapper {...props} />
    </EditableComponent>
  );
};
